/**
 * @file banner相关接口
 * @author putianyi
 */
import 'whatwg-fetch';
import {spyRequest as request} from '../log/index';
import API from './api';

/**
 * 获取banner列表
 * @returns Promise
*/
export const getBannerList = async (params = {}) => {
    return request(
        API.GET_BANNER_LIST, {
            method: 'POSTJSON',
            body: params
        }
    );
};